module.exports = __webpack_public_path__ + "media/images/front/icon_favorite-5944642e42643ee9703b86ac2c130233.png";